import { createFileRoute, useRouter, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { BuyTable } from '@/components/Pages/Buys/BuyTable';
import { Box, Button } from '@mui/joy';
import { Add as AddIcon } from '@mui/icons-material';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/buys/')({
  component: BuysPage,
  head: () => pageTitle('Compras'),
});

function BuysPage() {
  const router = useRouter();
  const { hasClaim, isLoading } = useAuth();

  const canRead = hasClaim('BUY_READ');
  const canWrite = hasClaim('BUY_WRITE');

  const handleCreateBuy = () => {
    router.navigate({ to: '/buys/create' });
  };

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        {canWrite && (
          <Button
            startDecorator={<AddIcon />}
            onClick={handleCreateBuy}
            variant='outlined'
            color='neutral'
          >
            Crear Compra
          </Button>
        )}
      </Box>

      <BuyTable />
    </Box>
  );
}
